import { logEvent } from '@/helpers/cieloLogger';
import store from '@/store';

export default {
    /**
     * Cria um novo campo no DOM para o mpi, caso o campo exista o mesmo é re-criado
     * @param {String} className Classe do mpi a ser criada
     * @param {String} value Valor da classe do mpi
     */
    addMpiField(className, value) {
        let existingField = document.getElementsByClassName(className);
        if (existingField.length > 0)
            document.body.removeChild(existingField[0]);

        let mpiInput =  document.createElement('input');
        mpiInput.className = className;
        mpiInput.type = 'hidden';
        mpiInput.value = value;

        document.body.appendChild(mpiInput);
    },

    /**
     * Retorna um campo do Mpi já registrado
     * @param {string} fieldName Nome do campo a ser retornado, sem o prefixo bpmpi_
     */
    getMpiField(fieldName) {
        let field = document.getElementsByClassName(`bpmpi_${fieldName}`)[0];
        return field.value;
    },

    /**
     * Configura os callbacks do mpi
     */
    setMpiCallbacks() {
        let isDataOnly = this.getMpiField('auth_notifyonly') == 'true';

        // Função de configuração do MPI
        window.bpmpi_config = function() {
            return {
                /**
                 * Script carregado, pronto para autenticar.
                 */
                onReady: () => {
                    logMpiEvent('onReady', 'Script carregado, iniciando processo de autenticação', isDataOnly);

                    store.commit('mpi/setMpiIsReady', true);
                    bpmpi_authenticate();
                },

                /**
                 * Cartão elegível para autenticação, e portador autenticou com sucesso.
                 * @param {string} e.Cavv Dado que representa assinatura da autenticação
                 * @param {string} e.Xid ID que representa a requisição da autenticação
                 * @param {string} e.Eci Código indicador do e-commerce, que representa o resultado da autenticação
                 * @param {string} e.Version Versão do 3DS aplicado
                 * @param {string} e.ReferenceId ID que representa a requisição de autenticação
                 */
                onSuccess: function (e) {
                    store.commit('mpi/setCavv', e.Cavv);
                    store.commit('mpi/setXid', e.Xid);
                    store.commit('mpi/setEci', e.Eci);
                    store.commit('mpi/setVersion', e.Version);
                    store.commit('mpi/setReferenceID', e.ReferenceId);

                    logMpiEvent('onSuccess', 'Cartão elegível para autenticação, e portador autenticou com sucesso', isDataOnly);

                    store.state.mpi.MpiPromiseCallback.resolve();
                },

                /**
                 * Cartão elegível para autenticação, porém o portador finalizou com falha.
                 * @param {string} e.Cavv Dado que representa assinatura da autenticação
                 * @param {string} e.Xid ID que representa a requisição da autenticação
                 * @param {string} e.Eci Código indicador do e-commerce, que representa o resultado da autenticação
                 * @param {string} e.Version Versão do 3DS aplicado
                 * @param {string} e.ReferenceId ID que representa a requisição de autenticação
                 */
                onFailure: function (e) {
                    store.commit('mpi/setCavv', e.Cavv);
                    store.commit('mpi/setXid', e.Xid);
                    store.commit('mpi/setEci', e.Eci);
                    store.commit('mpi/setVersion', e.Version);
                    store.commit('mpi/setReferenceID', e.ReferenceId);
                    
                    logMpiEvent('onFailure', 'Cartão elegível para autenticação, porém o portador finalizou com falha', isDataOnly);

                    if (isDataOnly && store.state.mpi.AutomaticCancellationWhenUnauthenticated == false)
                        store.state.mpi.MpiPromiseCallback.resolve();
                    else
                        store.state.mpi.MpiPromiseCallback.reject(store.state.mpi.multiLanguage.get('cardAuthenticationError'));
                },
                
                /**
                 * Cartão não elegível para autenticação (não autenticável).
                 * @param {string} e.Cavv Dado que representa assinatura da autenticação
                 * @param {string} e.Xid ID que representa a requisição da autenticação
                 * @param {string} e.Eci Código indicador do e-commerce, que representa o resultado da autenticação
                 * @param {string} e.Version Versão do 3DS aplicado
                 * @param {string} e.ReferenceId ID que representa a requisição de autenticação
                 */
                onUnenrolled: function (e) {
                    store.commit('mpi/setCavv', e.Cavv);
                    store.commit('mpi/setXid', e.Xid);
                    store.commit('mpi/setEci', e.Eci);
                    store.commit('mpi/setVersion', e.Version);
                    store.commit('mpi/setReferenceID', e.ReferenceId);

                    logMpiEvent('onUnenrolled', 'Cartão não elegível para autenticação (não autenticável)', isDataOnly);

                    if(store.state.mpi.AutomaticCancellationWhenUnauthenticated == true)
                        store.state.mpi.MpiPromiseCallback.reject(store.state.mpi.multiLanguage.get('cardAuthenticationError'));
                    else if (isDataOnly)
                        store.state.mpi.MpiPromiseCallback.resolve();
                    else
                        store.state.mpi.MpiPromiseCallback.reject(store.state.mpi.multiLanguage.get('notAuthenticableCardError'));
                },
                
                /**
                 * Loja não requer autenticação do portador (classe "bpmpi_auth" false -> autenticação desabilitada).
                 */
                onDisabled: function () {
                    store.state.mpi.MpiPromiseCallback.resolve();
                },

                /**
                 * Erro no processo de autenticação.
                 * @param {string} e.Cavv Dado que representa assinatura da autenticação
                 * @param {string} e.Xid ID que representa a requisição da autenticação
                 * @param {string} e.Eci Código indicador do e-commerce, que representa o resultado da autenticação
                 * @param {string} e.ReturnCode Código de retorno da requisição de autenticação
                 * @param {string} e.ReturnMessage Mensagem de retorno da requisição de autenticação
                 * @param {string} e.Version Versão do 3DS aplicado
                 * @param {string} e.ReferenceId ID que representa a requisição de autenticação
                 */
                onError: function (e) {
                    store.commit('mpi/setCavv', e.Cavv);
                    store.commit('mpi/setXid', e.Xid);
                    store.commit('mpi/setEci', e.Eci);
                    store.commit('mpi/setReturnCode', e.ReturnCode);
                    store.commit('mpi/setReturnMessage', e.ReturnMessage);
                    store.commit('mpi/setReferenceID', e.ReferenceId);

                    logMpiEvent('onError', 'Erro no processo de autenticação', isDataOnly);

                    if (isDataOnly && store.state.mpi.AutomaticCancellationWhenUnauthenticated == false)
                        store.state.mpi.MpiPromiseCallback.resolve();
                    else
                        store.state.mpi.MpiPromiseCallback.reject(store.state.mpi.multiLanguage.get('unexpectedAuthenticationError'), isDataOnly);
                },

                /**
                 * Bandeira não suportada para autenticação.
                 * @param {string} e.ReturnCode Código de retorno da requisição de autenticação
                 * @param {string} e.ReturnMessage Mensagem de retorno da requisição de autenticação
                 */
                onUnsupportedBrand: function (e) {
                    store.commit('mpi/setReturnCode', e.ReturnCode);
                    store.commit('mpi/setReturnMessage', e.ReturnMessage);
                    
                    logMpiEvent('onUnsupportedBrand', 'Bandeira não suportada para autenticação', isDataOnly);

                    if (isDataOnly && store.state.mpi.AutomaticCancellationWhenUnauthenticated == false)
                        store.state.mpi.MpiPromiseCallback.resolve();
                    else
                        store.state.mpi.MpiPromiseCallback.reject(store.state.mpi.multiLanguage.get('flagDoesNotSupport'));
                },
                Environment: store.state.mpi.Environment,
                Debug: store.state.mpi.Debug
            };
        };
    }
};

function logMpiEvent(mpiEvent, message, isDataOnly)
{
    let brand = store.getters['payment/getSelectedPaymentMethod'].Image || 'Indisponível';
    let isCreditAuthEnabled = store.state.mpi.CreditAuthenticationEnabled;
    let isDebitAuthEnabled = store.state.mpi.DebitAuthenticationEnabled;
    let logLabel = `Resultado: [${mpiEvent || 'sem evento'}] | ${message} | Brand: ${brand} | DataOnly: ${isDataOnly} | CreditAuth: ${isCreditAuthEnabled} | DebitAuth: ${isDebitAuthEnabled}`;

    logEvent({
        category: 'MPI',
        action: 'BPMPI_CONFIG',
        label: logLabel
    });
};
